(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-products"]) return;
  try {
    
/* Collection Products - Sort toggle + inline filter dropdowns */
(function() {
  /* Sort dropdown toggle */
  document.addEventListener('click', function(e) {
    var sortBtn = e.target.closest('.js-toggle-sort');
    if (sortBtn) {
      var dropdown = sortBtn.nextElementSibling;
      if (!dropdown) return;
      var isHidden = dropdown.hasAttribute('hidden');
      dropdown.toggleAttribute('hidden', !isHidden);
      sortBtn.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
      e.stopPropagation();
      return;
    }

    /* Close sort dropdown on outside click */
    var openDropdowns = document.querySelectorAll('.cp-sort-dropdown:not([hidden])');
    openDropdowns.forEach(function(dd) {
      if (!dd.contains(e.target)) {
        dd.setAttribute('hidden', '');
        var btn = dd.previousElementSibling;
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    });
  });

  /* Inline filter dropdowns: open one at a time, close on outside click */
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('.cp-fb-group__toggle');
    var openGroup = e.target.closest('.cp-fb-group');

    document.querySelectorAll('.cp-fb-group[open]').forEach(function(d) {
      /* keep the group being toggled; the <details> handles its own open/close */
      if (d !== openGroup) d.removeAttribute('open');
    });

    /* clicking inside the panel (not the toggle) must not collapse it */
    if (openGroup && !toggle) return;
  });

  /* Keep the clicked group's toggle (badge + active state) and its option row
     in sync immediately. facets.js routes the just-changed filter through its
     count-only path, which targets Dawn classes our markup doesn't use, so the
     summary of the clicked group would otherwise go stale. */
  document.addEventListener('change', function(e) {
    var input = e.target.closest('.cp-fb-option__input');
    var group = e.target.closest('.cp-fb-group');
    if (!group) return;

    if (input) {
      var option = input.closest('.cp-fb-option');
      if (option) option.classList.toggle('is-checked', input.checked);
    }

    var toggle = group.querySelector('.cp-fb-group__toggle');
    if (!toggle) return;

    var checkedCount = group.querySelectorAll('.cp-fb-option__input:checked').length;
    toggle.classList.toggle('is-active', checkedCount > 0);

    var badge = toggle.querySelector('.cp-fb-group__badge');
    if (checkedCount > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'cp-fb-group__badge';
        var caret = toggle.querySelector('.cp-fb-group__caret');
        toggle.insertBefore(badge, caret || null);
      }
      badge.textContent = checkedCount;
    } else if (badge) {
      badge.remove();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
      } else {
        this.header.classList.remove('scrolled-past-header');
      }

      this.currentScrollTop = scrollTop;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ───── Header Search Drawer ───── */
  class HeaderSearchDrawer {
    constructor(drawer) {
      this.drawer = drawer;
      this.toggle = document.querySelector('[data-search-toggle]');
      this.input = drawer.querySelector('[data-search-input]');
      this.results = drawer.querySelector('[data-search-results]');
      this.closers = drawer.querySelectorAll('[data-search-close]');
      this.controller = null;
      this.debounce = null;
      this.activeIndex = -1;
      this.lastQuery = '';

      if (!this.toggle || !this.input) return;

      this.toggle.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });

      this.closers.forEach((b) => b.addEventListener('click', () => this.close()));

      document.addEventListener('keydown', (e) => {
        if (!this.isOpen()) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          this.close();
        } else if (e.key === 'ArrowDown') {
          e.preventDefault();
          this.move(1);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          this.move(-1);
        } else if (e.key === 'Enter' && this.activeIndex >= 0) {
          const items = this.results.querySelectorAll('.header-search__result');
          const item = items[this.activeIndex];
          if (item) {
            e.preventDefault();
            window.location.href = item.href;
          }
        }
      });

      this.input.addEventListener('input', () => {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => this.search(this.input.value), 180);
      });
    }

    isOpen() {
      return this.drawer.classList.contains('is-open');
    }

    open() {
      this.drawer.removeAttribute('hidden');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('search-drawer-open');
      requestAnimationFrame(() => this.drawer.classList.add('is-open'));
      setTimeout(() => this.input.focus(), 220);
    }

    close() {
      this.drawer.classList.remove('is-open');
      this.toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('search-drawer-open');
      setTimeout(() => {
        this.drawer.setAttribute('hidden', '');
        this.drawer.setAttribute('aria-hidden', 'true');
        this.input.value = '';
        this.results.innerHTML = '';
        this.activeIndex = -1;
        this.lastQuery = '';
      }, 380);
      try { this.toggle.focus({ preventScroll: true }); } catch (_) {}
    }

    move(delta) {
      const items = this.results.querySelectorAll('.header-search__result');
      if (!items.length) return;
      this.activeIndex = (this.activeIndex + delta + items.length) % items.length;
      items.forEach((el, i) => {
        if (i === this.activeIndex) {
          el.classList.add('is-active');
          el.scrollIntoView({ block: 'nearest' });
        } else {
          el.classList.remove('is-active');
        }
      });
    }

    async search(query) {
      const q = (query || '').trim();
      if (q === this.lastQuery) return;
      this.lastQuery = q;
      this.activeIndex = -1;

      if (!q) {
        this.results.innerHTML = '';
        return;
      }

      if (this.controller) this.controller.abort();
      this.controller = new AbortController();

      try {
        const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        const res = await fetch(url, { signal: this.controller.signal });
        const data = await res.json();
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        this.render(products, q);
      } catch (err) {
        if (err.name !== 'AbortError') console.error('[search]', err);
      }
    }

    render(products, query) {
      if (!products.length) {
        this.results.innerHTML = '<div class="header-search__empty">nada por aqui... tente outra palavra ✨</div>';
        return;
      }

      const fmt = (price) => {
        // /search/suggest.json retorna price já em reais como string ("79.00")
        const n = Number(price) || 0;
        return 'R$ ' + n.toFixed(2).replace('.', ',');
      };
      const escape = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      }[c]));

      const items = products.map((p, i) => {
        const img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : '';
        const thumb = img ? '<img src="' + img + '" alt="" loading="lazy" width="56" height="56">' : '';
        return '<a href="' + escape(p.url) + '" class="header-search__result" role="option" style="animation-delay:' + (i * 55) + 'ms">'
          + '<span class="header-search__result-thumb">' + thumb + '</span>'
          + '<span class="header-search__result-info">'
          +   '<span class="header-search__result-title">' + escape(p.title) + '</span>'
          +   (p.vendor ? '<span class="header-search__result-meta">' + escape(p.vendor) + '</span>' : '')
          + '</span>'
          + '<span class="header-search__result-price">' + fmt(p.price) + '</span>'
          + '</a>';
      }).join('');

      this.results.innerHTML = items
        + '<a href="/search?q=' + encodeURIComponent(query) + '" class="header-search__view-all">Ver todos os resultados</a>';
    }
  }

  function bootstrapHeaderSearch() {
    document.querySelectorAll('[data-search-drawer]').forEach((d) => {
      if (!d.__hsd) d.__hsd = new HeaderSearchDrawer(d);
    });
  }

  if (document.readyState !== 'loading') {
    bootstrapHeaderSearch();
  } else {
    document.addEventListener('DOMContentLoaded', bootstrapHeaderSearch);
  }
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('[data-search-drawer]')) bootstrapHeaderSearch();
  });

  /* ───── Priority+ Navigation (desktop) ─────
     Mede o nav e move itens que não caberiam para um dropdown "Mais".
     Recalcula no resize. Funciona só quando o nav está visível (≥ 990px). */
  class PriorityNav {
    constructor(nav) {
      this.nav = nav;
      this.list = nav.querySelector('.header__nav-list');
      this.items = Array.from(nav.querySelectorAll('[data-nav-item]'));
      this.moreLi = nav.querySelector('[data-nav-more]');
      this.moreList = nav.querySelector('[data-nav-more-list]');
      if (!this.list || !this.items.length || !this.moreLi || !this.moreList) return;

      this.buildMoreList();
      this.recompute = this.recompute.bind(this);

      this.ro = new ResizeObserver(() => requestAnimationFrame(this.recompute));
      this.ro.observe(this.nav);
      this.ro.observe(this.nav.parentElement);
      window.addEventListener('resize', this.recompute, { passive: true });
      window.addEventListener('load', this.recompute);
      requestAnimationFrame(this.recompute);
    }

    buildMoreList() {
      this.items.forEach((li) => {
        const trigger = li.querySelector('.header__nav-link');
        if (!trigger) return;
        let href = '#';
        if (trigger.tagName === 'A') {
          href = trigger.getAttribute('href') || '#';
        } else {
          const sibling = li.querySelector('a[href]');
          href = sibling ? sibling.getAttribute('href') : '#';
        }
        const title = (trigger.textContent || '').trim().replace(/\s+/g, ' ');

        // Submenu original do item (não o do próprio botão "Mais")
        const submenu = li.querySelector('.header__submenu:not(.header__submenu--more)');
        // Só os filhos diretos (os netos ficam aninhados dentro de cada filho)
        const childItems = submenu ? Array.from(submenu.children).filter((el) => el.tagName === 'LI') : [];
        const childLinks = childItems.map((cli) => cli.querySelector(':scope > a[href]')).filter(Boolean);

        const wrapperLi = document.createElement('li');
        wrapperLi.hidden = true;

        if (childLinks.length > 0) {
          // Item com submenu: vira um grupo com fly-out lateral (hover/focus mostra os filhos)
          wrapperLi.className = 'header__more-group';
          const parentA = document.createElement('a');
          parentA.href = href;
          parentA.className = 'header__submenu-link header__more-group__title';
          parentA.textContent = title;
          const arrow = document.createElement('span');
          arrow.className = 'header__more-group__arrow';
          arrow.setAttribute('aria-hidden', 'true');
          arrow.textContent = '‹';
          parentA.appendChild(arrow);
          wrapperLi.appendChild(parentA);

          const childUl = document.createElement('ul');
          childUl.className = 'header__more-group__flyout';
          childUl.setAttribute('role', 'list');
          childLinks.forEach((child) => {
            const cli = document.createElement('li');
            const ca = document.createElement('a');
            ca.href = child.getAttribute('href') || '#';
            ca.className = 'header__submenu-link';
            const label = child.cloneNode(true);
            label.querySelectorAll('.header__submenu-arrow').forEach((el) => el.remove());
            ca.textContent = (label.textContent || '').trim().replace(/\s+/g, ' ');
            cli.appendChild(ca);

            // 3º nível: netos entram como lista recuada logo abaixo do filho
            const nested = child.parentElement.querySelector(':scope > .header__submenu--nested');
            if (nested) {
              cli.className = 'header__more-subgroup';
              ca.classList.add('header__more-subgroup__title');
              const gUl = document.createElement('ul');
              gUl.className = 'header__more-subgroup__list';
              gUl.setAttribute('role', 'list');
              nested.querySelectorAll(':scope > li > a[href]').forEach((g) => {
                const gli = document.createElement('li');
                const ga = document.createElement('a');
                ga.href = g.getAttribute('href') || '#';
                ga.className = 'header__submenu-link header__submenu-link--grandchild';
                ga.textContent = (g.textContent || '').trim().replace(/\s+/g, ' ');
                gli.appendChild(ga);
                gUl.appendChild(gli);
              });
              cli.appendChild(gUl);
            }
            childUl.appendChild(cli);
          });
          wrapperLi.appendChild(childUl);
        } else {
          // Item simples: 1 link só
          const a = document.createElement('a');
          a.href = href;
          a.className = 'header__submenu-link';
          a.textContent = title;
          wrapperLi.appendChild(a);
        }

        this.moreList.appendChild(wrapperLi);
      });
    }

    recompute() {
      // Só roda quando o nav está visível (desktop)
      if (getComputedStyle(this.nav).display === 'none') return;

      // 1. Reset: mostra tudo, esconde "Mais"
      this.items.forEach((li) => { li.hidden = false; });
      this.moreLi.hidden = false;
      Array.from(this.moreList.children).forEach((li) => { li.hidden = true; });

      // 2. Mede largura do "Mais" enquanto está visível mas vazio
      const moreWidth = this.moreLi.getBoundingClientRect().width;

      // 3. Esconde "Mais" antes de medir os itens (assim cabem normalmente)
      this.moreLi.hidden = true;

      // 4. Mede largura disponível e largura natural de cada item
      const navWidth = this.nav.clientWidth;
      const gapPx = parseFloat(getComputedStyle(this.list).columnGap || getComputedStyle(this.list).gap) || 0;
      const widths = this.items.map((li) => li.getBoundingClientRect().width);

      // 5. Encontra o primeiro item que não cabe
      let running = 0;
      let overflowAt = -1;
      for (let i = 0; i < this.items.length; i++) {
        const candidate = running + (i > 0 ? gapPx : 0) + widths[i];
        if (candidate > navWidth) {
          overflowAt = i;
          break;
        }
        running = candidate;
      }

      // Todos cabem → some com o "Mais"
      if (overflowAt < 0) return;

      // 6. Sobra espaço pro botão "Mais" também?
      // Volta atrás até o "Mais" caber junto com os itens restantes.
      while (overflowAt > 0) {
        let sum = 0;
        for (let i = 0; i < overflowAt; i++) {
          sum += widths[i] + (i > 0 ? gapPx : 0);
        }
        if (sum + gapPx + moreWidth <= navWidth) break;
        overflowAt--;
      }

      // 7. Aplica: esconde os items overflow + popula o dropdown
      for (let i = overflowAt; i < this.items.length; i++) {
        this.items[i].hidden = true;
        const mirror = this.moreList.children[i];
        if (mirror) mirror.hidden = false;
      }
      this.moreLi.hidden = false;
    }
  }

  function bootstrapPriorityNav() {
    document.querySelectorAll('[data-priority-nav]').forEach((nav) => {
      if (!nav.__pnav) nav.__pnav = new PriorityNav(nav);
    });
  }

  if (document.readyState !== 'loading') {
    bootstrapPriorityNav();
  } else {
    document.addEventListener('DOMContentLoaded', bootstrapPriorityNav);
  }
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('[data-priority-nav]')) bootstrapPriorityNav();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-banner-slider"] && !Shopify.designMode) return;
  try {
    
  /* Autoplay próprio do banner slider — o SlideshowComponent do Dawn aborta o
     autoplay quando não há .slider-buttons/.slideshow__autoplay (nosso layout
     simplificado). As setas (prev/next) continuam vindo do SliderComponent. */
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initAutoplay(root) {
      if (!root || root.dataset.autoplayBound === 'true') return;
      var slider = root.querySelector('[id^="Slider-"]');
      if (!slider || slider.getAttribute('data-autoplay') !== 'true') return;

      var slides = root.querySelectorAll('[id^="Slide-"]');
      if (slides.length < 2) return;

      root.dataset.autoplayBound = 'true';

      var speed = (parseFloat(slider.dataset.speed) || 5) * 1000;
      var index = 0;
      var timer = null;

      function goTo(n) {
        index = (n + slides.length) % slides.length;
        var left = slides[index].offsetLeft - slides[0].offsetLeft;
        slider.scrollTo({ left: left, behavior: 'smooth' });
      }

      function start() {
        if (timer || reduceMotion.matches) return;
        timer = setInterval(function () { goTo(index + 1); }, speed);
      }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      /* Mantém o índice em sincronia com navegação manual / arrasto */
      var scrollDebounce;
      slider.addEventListener('scroll', function () {
        clearTimeout(scrollDebounce);
        scrollDebounce = setTimeout(function () {
          var nearest = 0;
          var min = Infinity;
          for (var i = 0; i < slides.length; i++) {
            var d = Math.abs((slides[i].offsetLeft - slides[0].offsetLeft) - slider.scrollLeft);
            if (d < min) { min = d; nearest = i; }
          }
          index = nearest;
        }, 120);
      }, { passive: true });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      reduceMotion.addEventListener('change', function () {
        reduceMotion.matches ? stop() : start();
      });

      start();
    }

    function bootstrap() {
      document.querySelectorAll('.home-banner-slider').forEach(initAutoplay);
    }

    if (document.readyState !== 'loading') {
      bootstrap();
    } else {
      document.addEventListener('DOMContentLoaded', bootstrap);
    }

    /* Theme editor: re-inicia ao recarregar a seção */
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('.home-banner-slider');
      if (root) {
        root.dataset.autoplayBound = '';
        initAutoplay(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-custom"] && !Shopify.designMode) return;
  try {
    
/* ═══════════════════════════════════════════════════
   YUPER — PRODUCT GALLERY + INTERACTIONS
   ═══════════════════════════════════════════════════ */

(function() {
  'use strict';

  class YpProductGallery {
    constructor(sectionId) {
      this.section = document.getElementById('MainProductCustom-' + sectionId);
      if (!this.section) return;

      this.track = this.section.querySelector('.yp-gallery__track');
      this.slides = this.section.querySelectorAll('.yp-gallery__slide');
      this.thumbs = this.section.querySelectorAll('.yp-gallery__thumb');
      this.prevBtn = this.section.querySelector('.yp-gallery__arrow--prev');
      this.nextBtn = this.section.querySelector('.yp-gallery__arrow--next');
      this.counterCurrent = this.section.querySelector('.yp-gallery__counter-current');

      this.sectionId = sectionId;
      this.currentIndex = 0;
      this.totalSlides = this.slides.length;
      this.hasHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      /* true enquanto o último gesto de toque foi um zoom (bloqueia swipe/click) */
      this.touchZoomed = false;

      this.setupHoverZoom();
      this.setupTouchZoom();
      this.setupLightbox();

      if (this.totalSlides <= 1) return;

      this.bindEvents();
      this.setupSwipe();
    }

    activeImage() {
      const slide = this.slides[this.currentIndex];
      return slide ? slide.querySelector('.yp-gallery__image') : null;
    }

    /* Origem do zoom segue o cursor/dedo. rect é o box NÃO transformado. */
    static setZoom(img, rect, clientX, clientY, scale) {
      const x = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
      const y = Math.min(100, Math.max(0, ((clientY - rect.top) / rect.height) * 100));
      img.style.transformOrigin = x + '% ' + y + '%';
      img.style.transform = 'scale(' + scale + ')';
    }

    static resetZoom(img) {
      if (!img) return;
      img.style.transform = '';
      img.style.transformOrigin = '';
    }

    /* Desktop: zoom ao passar o mouse na imagem da galeria */
    setupHoverZoom() {
      if (!this.hasHover) return;
      this.slides.forEach((slide) => {
        const img = slide.querySelector('.yp-gallery__image');
        if (!img) return;
        slide.addEventListener('mousemove', (e) => {
          YpProductGallery.setZoom(img, slide.getBoundingClientRect(), e.clientX, e.clientY, 2);
        });
        slide.addEventListener('mouseleave', () => YpProductGallery.resetZoom(img));
      });
    }

    /* Mobile: segurar o dedo (~200ms parado) ativa o zoom que segue o dedo.
       Swipe rápido continua trocando de imagem; tap abre o lightbox. */
    setupTouchZoom() {
      if (this.hasHover) return;
      const viewport = this.section.querySelector('.yp-gallery__viewport');
      if (!viewport) return;

      let holdTimer = null;
      let zooming = false;
      let startX = 0;
      let startY = 0;

      viewport.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) return;
        this.touchZoomed = false;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        holdTimer = setTimeout(() => {
          const slide = this.slides[this.currentIndex];
          const img = this.activeImage();
          if (!slide || !img) return;
          zooming = true;
          this.touchZoomed = true;
          YpProductGallery.setZoom(img, slide.getBoundingClientRect(), startX, startY, 2);
        }, 200);
      }, { passive: true });

      viewport.addEventListener('touchmove', (e) => {
        const t = e.touches[0];
        if (!zooming) {
          /* Moveu antes do hold: é swipe/scroll, cancela o zoom */
          if (Math.abs(t.clientX - startX) > 10 || Math.abs(t.clientY - startY) > 10) {
            clearTimeout(holdTimer);
          }
          return;
        }
        e.preventDefault();
        const slide = this.slides[this.currentIndex];
        const img = this.activeImage();
        if (slide && img) {
          YpProductGallery.setZoom(img, slide.getBoundingClientRect(), t.clientX, t.clientY, 2);
        }
      }, { passive: false });

      const endZoom = () => {
        clearTimeout(holdTimer);
        if (!zooming) return;
        zooming = false;
        YpProductGallery.resetZoom(this.activeImage());
      };
      viewport.addEventListener('touchend', endZoom);
      viewport.addEventListener('touchcancel', endZoom);
    }

    /* Lightbox: clique/tap abre a imagem grande; mouse/dedo dá zoom; botão fecha */
    setupLightbox() {
      this.lightbox = this.section.querySelector('.yp-lightbox') ||
        document.getElementById('YpLightbox-' + this.sectionId);
      if (!this.lightbox) return;

      /* Remove órfão de um load anterior da seção (editor de temas) */
      document.querySelectorAll('#YpLightbox-' + CSS.escape(this.sectionId)).forEach((el) => {
        if (el !== this.lightbox) el.remove();
      });

      /* Fora da section pra escapar de sticky/transform ancestrais */
      document.body.appendChild(this.lightbox);

      const img = this.lightbox.querySelector('.yp-lightbox__img');
      const stage = this.lightbox.querySelector('.yp-lightbox__stage');
      const closeBtn = this.lightbox.querySelector('.yp-lightbox__close');
      const ZOOM = 2.2;

      /* Box da imagem sem transform — capturado no início de cada gesto de zoom */
      let baseRect = null;
      const zoomAt = (clientX, clientY) => {
        if (!baseRect) baseRect = img.getBoundingClientRect();
        YpProductGallery.setZoom(img, baseRect, clientX, clientY, ZOOM);
      };
      const resetZoom = () => {
        YpProductGallery.resetZoom(img);
        baseRect = null;
      };

      this.slides.forEach((slide) => {
        slide.addEventListener('click', () => {
          if (this.touchZoomed) return;
          const slideImg = slide.querySelector('.yp-gallery__image');
          if (!slideImg) return;
          YpProductGallery.resetZoom(slideImg);
          img.src = slideImg.dataset.zoomSrc || slideImg.currentSrc || slideImg.src;
          img.alt = slideImg.alt || '';
          if (slideImg.width && slideImg.height) {
            img.width = slideImg.getAttribute('width');
            img.height = slideImg.getAttribute('height');
          }
          this.lightbox.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        });
      });

      const close = () => {
        this.lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        resetZoom();
      };
      closeBtn.addEventListener('click', close);
      stage.addEventListener('click', (e) => {
        if (e.target !== img) close();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.lightbox.getAttribute('aria-hidden') === 'false') close();
      });

      if (this.hasHover) {
        img.addEventListener('mousemove', (e) => zoomAt(e.clientX, e.clientY));
        img.addEventListener('mouseleave', resetZoom);
      } else {
        stage.addEventListener('touchmove', (e) => {
          if (e.touches.length !== 1) return;
          e.preventDefault();
          zoomAt(e.touches[0].clientX, e.touches[0].clientY);
        }, { passive: false });
        stage.addEventListener('touchend', resetZoom);
        stage.addEventListener('touchcancel', resetZoom);
      }
    }

    bindEvents() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.currentIndex + 1));

      this.thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const idx = parseInt(thumb.dataset.index, 10);
          this.goTo(idx);
        });
      });
    }

    setupSwipe() {
      let startX = 0;
      let deltaX = 0;
      const viewport = this.track.parentElement;

      viewport.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        deltaX = 0;
      }, { passive: true });

      viewport.addEventListener('touchmove', (e) => {
        deltaX = e.touches[0].clientX - startX;
      }, { passive: true });

      viewport.addEventListener('touchend', () => {
        if (this.touchZoomed) return;
        if (Math.abs(deltaX) > 40) {
          if (deltaX < 0) this.goTo(this.currentIndex + 1);
          else this.goTo(this.currentIndex - 1);
        }
      });
    }

    goTo(index) {
      if (index < 0) index = this.totalSlides - 1;
      if (index >= this.totalSlides) index = 0;

      this.currentIndex = index;
      this.track.style.transform = 'translateX(-' + (index * 100) + '%)';

      this.slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      this.thumbs.forEach((t, i) => {
        t.classList.toggle('is-active', i === index);
        if (i === index) t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });

      if (this.counterCurrent) this.counterCurrent.textContent = index + 1;
    }
  }

  /* Quantity selector */
  function initQuantity(section) {
    const minusBtn = section.querySelector('.yp-qty__btn--minus');
    const plusBtn = section.querySelector('.yp-qty__btn--plus');
    const input = section.querySelector('.yp-qty__input');
    if (!minusBtn || !plusBtn || !input) return;

    minusBtn.addEventListener('click', () => {
      const val = parseInt(input.value, 10) || 1;
      if (val > 1) input.value = val - 1;
    });

    plusBtn.addEventListener('click', () => {
      const val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
    });
  }

  /* Size Guide modal */
  function initSizeGuide(section) {
    const sectionId = section.dataset.sectionId;
    const btn = document.getElementById('YpSizeGuideBtn-' + sectionId);
    const modal = document.getElementById('YpSizeModal-' + sectionId);
    if (!btn || !modal) return;

    document.body.appendChild(modal);

    const content = modal.querySelector('.yp-size-modal__content');
    const closeBtn = modal.querySelector('.yp-size-modal__close');

    btn.addEventListener('click', () => {
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => {
      if (!content.contains(e.target)) closeModal();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
    });
  }

  /* UGC Videos modal */
  function initUgcVideos(section) {
    const sectionId = section.dataset.sectionId;
    const modal = document.getElementById('YpUgcModal-' + sectionId);
    if (!modal) return;

    document.body.appendChild(modal);

    const video = modal.querySelector('.yp-ugc-modal__video');
    const closeBtn = modal.querySelector('.yp-ugc-modal__close');
    const content = modal.querySelector('.yp-ugc-modal__content');
    const thumbs = section.querySelectorAll('.yp-ugc-videos__thumb');

    function openModal(src) {
      video.src = src;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      video.play().catch(() => {});
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      video.pause();
      video.removeAttribute('src');
      video.load();
      document.body.style.overflow = '';
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const url = thumb.dataset.ugcVideoUrl;
        if (url) openModal(url);
      });
    });

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => {
      if (!content.contains(e.target)) closeModal();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
    });
  }

  /* Variant sync — keep hidden id + URL in sync with radios */
  function initVariantSync(section) {
    const variantSelects = section.querySelector('variant-selects');
    if (!variantSelects) return;

    const dataEl = variantSelects.querySelector('script[data-product-variants]');
    if (!dataEl) return;

    let variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    const idInput = section.querySelector('input[name="id"].product-variant-id');
    const mainAtcBtn = section.querySelector('.yp-product__actions .yp-btn--atc');
    const mainAtcLabel = mainAtcBtn ? mainAtcBtn.querySelector('span') : null;
    const stickyBar = section.querySelector('[data-yp-sticky-atc]');
    const stickyBtn = section.querySelector('[data-sticky-atc-btn]');
    const stickyLabel = section.querySelector('[data-sticky-atc-label]');
    const stickyPriceCurrent = section.querySelector('[data-sticky-price-current]');
    const stickyPriceCompare = section.querySelector('[data-sticky-price-compare]');
    const stickySelect = section.querySelector('[data-sticky-variant-select]');

    const priceBlock = section.querySelector('[data-yp-price-block]');
    const priceRow = priceBlock ? priceBlock.querySelector('.yp-price__row') : null;
    const priceCurrent = priceBlock ? priceBlock.querySelector('.yp-price__current') : null;
    const installmentsEl = priceBlock ? priceBlock.querySelector('.yp-price__installments') : null;
    const installmentsN = priceBlock ? parseInt(priceBlock.dataset.installments, 10) : 0;

    const currencyCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL';
    const moneyFmt = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
      style: 'currency',
      currency: currencyCode,
    });
    function formatMoney(cents) {
      const value = Number(cents) / 100;
      if (!isFinite(value)) return '';
      return moneyFmt.format(value);
    }

    function currentOptionValues() {
      return Array.from(variantSelects.querySelectorAll('fieldset.yp-option')).map(fs => {
        const checked = fs.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(values) {
      return variants.find(v => {
        if (!v.options || v.options.length !== values.length) return false;
        return v.options.every((opt, i) => opt === values[i]);
      });
    }

    function updateUrl(variantId) {
      if (!window.history || !window.history.replaceState) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }

    function setBtnState(btn, available) {
      if (!btn) return;
      if (available) btn.removeAttribute('disabled');
      else btn.setAttribute('disabled', '');
    }

    function sync() {
      const variant = findVariant(currentOptionValues());
      if (!variant) return;

      // Atualiza data-variant-available pro CSS trocar entre ATC e botão "Avise-me" do plugin.
      // Como o plugin seta `display: flex !important` inline (vence CSS), também aplico
      // display via JS no botão notify pra garantir o swap. Idempotente — só muda se
      // ainda não estiver no estado certo, pra não disparar re-render do plugin em cadeia.
      const newAvail = variant.available ? 'true' : 'false';
      if (section.dataset.variantAvailable !== newAvail) {
        section.dataset.variantAvailable = newAvail;
      }
      // Force display via inline style — o plugin originalmente seta `display: flex !important`
      // inline, então precisamos manter `flex` ao mostrar (não usar removeProperty senão
      // perdemos o display do botão e ele vira inline-block sem layout flex).
      section.querySelectorAll('.restock-alerts-notify-button, .PRODUCT_PAGE-notify-button, .notifyButtonStyle').forEach((btn) => {
        const target = variant.available ? 'none' : 'flex';
        if (btn.style.display !== target) {
          btn.style.setProperty('display', target, 'important');
        }
      });

      if (idInput) {
        idInput.value = variant.id;
        setBtnState(idInput, variant.available);
      }

      setBtnState(mainAtcBtn, variant.available);
      if (mainAtcLabel) {
        mainAtcLabel.textContent = variant.available ? 'Adicionar ao carrinho' : 'Esgotado';
      }

      setBtnState(stickyBtn, variant.available);
      if (stickyLabel) {
        stickyLabel.textContent = variant.available ? 'Adicionar' : 'Esgotado';
      }
      if (stickyPriceCurrent) {
        stickyPriceCurrent.textContent = formatMoney(variant.price);
      }
      if (stickyPriceCompare) {
        const hasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (hasDiscount) {
          stickyPriceCompare.textContent = formatMoney(variant.compare_at_price);
          stickyPriceCompare.removeAttribute('hidden');
        } else {
          stickyPriceCompare.textContent = '';
          stickyPriceCompare.setAttribute('hidden', '');
        }
      }

      if (stickySelect && String(stickySelect.value) !== String(variant.id)) {
        stickySelect.value = String(variant.id);
      }

      // Bloco de preço principal — espelha o mesmo comportamento da barra fixa.
      const hasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (priceCurrent) {
        priceCurrent.textContent = formatMoney(variant.price);
      }
      if (priceRow && priceCurrent) {
        let compareEl = priceRow.querySelector('.yp-price__compare');
        let badgeEl = priceRow.querySelector('.yp-price__badge');
        if (hasDiscount) {
          const pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          if (!compareEl) {
            compareEl = document.createElement('span');
            compareEl.className = 'yp-price__compare';
            priceRow.insertBefore(compareEl, priceCurrent);
          }
          compareEl.textContent = formatMoney(variant.compare_at_price);
          if (!badgeEl) {
            badgeEl = document.createElement('span');
            badgeEl.className = 'yp-price__badge';
            priceRow.appendChild(badgeEl);
          }
          badgeEl.textContent = '-' + pct + '%';
        } else {
          if (compareEl) compareEl.remove();
          if (badgeEl) badgeEl.remove();
        }
      }
      if (installmentsEl && installmentsN > 0) {
        const per = Math.ceil(variant.price / installmentsN);
        installmentsEl.textContent = 'ou ' + installmentsN + 'x de ' + formatMoney(per) + ' sem juros';
      }

      updateUrl(variant.id);
    }

    variantSelects.addEventListener('change', sync);

    // Sync inicial + fallbacks pra pegar o botão notify do plugin (que é
    // injetado de forma assíncrona depois do page load).
    // Evitamos MutationObserver porque o plugin re-renderiza o próprio botão
    // continuamente e isso causa loop com qualquer observer.
    sync();
    setTimeout(sync, 500);
    setTimeout(sync, 1500);
    setTimeout(sync, 3000);

    /* Sticky select → propagate to radios so the main UI + sync stay in sync */
    if (stickySelect) {
      stickySelect.addEventListener('change', () => {
        const variant = variants.find(v => String(v.id) === String(stickySelect.value));
        if (!variant) return;

        const fieldsets = Array.from(variantSelects.querySelectorAll('fieldset.yp-option'));
        fieldsets.forEach((fs, i) => {
          const target = variant.options[i];
          const radio = fs.querySelector(`input[type="radio"][value="${CSS.escape(target)}"]`);
          if (radio && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        /* If product has no options-as-radios (defensive), still run sync */
        if (!fieldsets.length) sync();
      });
    }

    if (stickyBar) {
      const mobileMql = window.matchMedia('(max-width: 749.98px)');
      let io = null;

      function showBar() { stickyBar.classList.add('is-visible'); }
      function hideBar() { stickyBar.classList.remove('is-visible'); }

      function setupVisibility() {
        if (io) { io.disconnect(); io = null; }
        if (mobileMql.matches) {
          showBar();
        } else if (mainAtcBtn && 'IntersectionObserver' in window) {
          io = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) hideBar();
            else showBar();
          }, { threshold: 0, rootMargin: '0px 0px -8px 0px' });
          io.observe(mainAtcBtn);
        } else {
          hideBar();
        }
      }

      requestAnimationFrame(setupVisibility);
      mobileMql.addEventListener('change', setupVisibility);
    }
  }

  /* Init on load + section re-render */
  function init() {
    document.querySelectorAll('.yp-product').forEach(section => {
      const sectionId = section.dataset.sectionId;
      new YpProductGallery(sectionId);
      initQuantity(section);
      initSizeGuide(section);
      initUgcVideos(section);
      initVariantSync(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify theme editor support */
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const section = e.target;
      if (section.classList.contains('yp-product')) {
        const sectionId = section.dataset.sectionId;
        new YpProductGallery(sectionId);
        initQuantity(section);
        initSizeGuide(section);
        initUgcVideos(section);
        initVariantSync(section);
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-logos"] && !Shopify.designMode) return;
  try {
    
  class PressLogosMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pl-track');
      this.inner = this.querySelector('.pl-track__inner');
      if (!this.track || !this.inner) return;

      this.speed = parseFloat(this.dataset.speed) || 25;
      this.offset = 0;
      this.paused = false;
      this.rafId = null;

      this.addEventListener('mouseenter', () => (this.paused = true));
      this.addEventListener('mouseleave', () => (this.paused = false));

      const images = this.inner.querySelectorAll('img');
      if (images.length === 0) {
        this.init();
        return;
      }

      let loaded = 0;
      const total = images.length;
      const onLoad = () => {
        loaded++;
        if (loaded >= total) this.init();
      };

      images.forEach((img) => {
        if (img.complete) {
          onLoad();
        } else {
          img.addEventListener('load', onLoad);
          img.addEventListener('error', onLoad);
        }
      });
    }

    init() {
      const wrapperWidth = this.offsetWidth;
      const innerWidth = this.inner.scrollWidth;

      if (innerWidth === 0) return;

      const copies = Math.ceil((wrapperWidth * 2) / innerWidth) + 1;

      for (let i = 0; i < copies; i++) {
        const clone = this.inner.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
        this.track.appendChild(clone);
      }

      this.singleWidth = innerWidth;
      this.pixelsPerSecond = this.singleWidth / this.speed;
      this.lastTime = null;

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.rafId = requestAnimationFrame((t) => this.animate(t));
      }
    }

    animate(timestamp) {
      if (!this.lastTime) this.lastTime = timestamp;
      const delta = (timestamp - this.lastTime) / 1000;
      this.lastTime = timestamp;

      if (!this.paused) {
        this.offset -= this.pixelsPerSecond * delta;
        if (Math.abs(this.offset) >= this.singleWidth) {
          this.offset += this.singleWidth;
        }
        this.track.style.transform = `translateX(${this.offset}px)`;
      }

      this.rafId = requestAnimationFrame((t) => this.animate(t));
    }

    disconnectedCallback() {
      if (this.rafId) cancelAnimationFrame(this.rafId);
    }
  }

  if (!customElements.get('press-logos-marquee')) {
    customElements.define('press-logos-marquee', PressLogosMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTabs(section) {
      const tabs = section.querySelectorAll('.ptabs__tab');
      const panels = section.querySelectorAll('.ptabs__panel');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('hidden', '');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          const targetId = tab.dataset.target;
          const targetPanel = section.querySelector('#' + targetId);
          if (targetPanel) {
            targetPanel.classList.add('is-active');
            targetPanel.removeAttribute('hidden');
          }
        });
      });
    }

    function bootstrap() {
      document.querySelectorAll('.ptabs').forEach(initTabs);
    }

    if (document.readyState !== 'loading') {
      bootstrap();
    } else {
      document.addEventListener('DOMContentLoaded', bootstrap);
    }

    document.addEventListener('shopify:section:load', function (e) {
      const sec = e.target.querySelector('.ptabs');
      if (sec) initTabs(sec);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof"] && !Shopify.designMode) return;
  try {
    
  class SocialProofCarousel extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.cards = [...this.querySelectorAll('.sp-card')];
      this.dots = [...this.querySelectorAll('.sp-dot')];
      this.totalCards = this.cards.length;
      this.visibleSlots = 4;

      this.prevBtn = this.querySelector('.sp-arrow--prev');
      this.nextBtn = this.querySelector('.sp-arrow--next');

      this.touchStartX = 0;
      this.touchEndX = 0;
    }

    connectedCallback() {
      if (this.totalCards === 0) return;

      this.detectSlots();
      this.updateView();
      this.bindEvents();

      this.resizeObserver = new ResizeObserver(() => {
        this.detectSlots();
        this.updateView();
      });
      this.resizeObserver.observe(this);

      // Lazy: só pré-aquece o vídeo (preload=metadata) quando a seção
      // se aproxima do viewport. Antes disso todos ficam em preload="none".
      this.warmObserver = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.warmUpFeatured();
          this.warmObserver.disconnect();
        }
      }, { rootMargin: '200px 0px' });
      this.warmObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.warmObserver) this.warmObserver.disconnect();
    }

    warmUpFeatured() {
      const target = this.querySelector('.sp-card.is-featured video')
        || this.querySelector('.sp-card.is-visible video');
      if (target && target.preload === 'none') target.preload = 'metadata';
    }

    detectSlots() {
      const width = this.offsetWidth;
      this.isMobile = width <= 749;
      this.visibleSlots = this.isMobile ? this.totalCards : 4;
    }

    bindEvents() {
      this.prevBtn?.addEventListener('click', () => this.navigate(-1));
      this.nextBtn?.addEventListener('click', () => this.navigate(1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.activeIndex = parseInt(dot.dataset.index, 10);
          this.updateView();
        });
      });

      // Click on card: toggle play/pause
      this.cards.forEach((card, cardIndex) => {
        card.addEventListener('click', () => {
          const video = card.querySelector('video');
          if (!video) return;

          if (video.paused) {
            // Pause all other videos first
            this.cards.forEach((c) => {
              const v = c.querySelector('video');
              if (v && v !== video) {
                v.pause();
                c.classList.remove('is-playing');
              }
            });
            this.playVideo(video);
            card.classList.add('is-playing');
          } else {
            video.pause();
            card.classList.remove('is-playing');
          }
        });
      });

      // Mute toggle
      this.querySelectorAll('.sp-card__mute-btn').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleMute();
        });
      });

      // Touch/swipe
      this.addEventListener('touchstart', (e) => {
        this.touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        this.touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe();
      }, { passive: true });

      // Keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.navigate(-1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.navigate(1);
        }
      });

      // Make carousel focusable for keyboard nav
      if (!this.hasAttribute('tabindex')) {
        this.setAttribute('tabindex', '0');
      }
    }

    navigate(direction) {
      this.activeIndex = ((this.activeIndex + direction) % this.totalCards + this.totalCards) % this.totalCards;
      this.updateView();
    }

    playVideo(video) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const card = video.closest('.sp-card');

      // Listen for pause to remove is-playing
      if (!video._pauseListenerAdded) {
        video.addEventListener('pause', () => {
          card?.classList.remove('is-playing');
        });
        video._pauseListenerAdded = true;
      }

      if (video.readyState >= 3) {
        video.play().catch(() => {});
      } else {
        const onCanPlay = () => {
          video.play().catch(() => {});
          video.removeEventListener('canplay', onCanPlay);
        };
        video.addEventListener('canplay', onCanPlay);
        if (video.preload !== 'auto') video.preload = 'auto';
        video.load();
      }
    }

    updateView() {
      // Mobile: show all cards, no featured state — CSS handles the slider.
      // Não bumpamos preload aqui — deixamos "none" até o click ou até o
      // warmObserver detectar entrada no viewport.
      if (this.isMobile) {
        this.cards.forEach((card) => {
          card.classList.add('is-visible');
          card.classList.remove('is-featured');
        });
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === 0);
          dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        });
        return;
      }

      // Desktop: marca destacado/visíveis, mas mantém preload="none".
      // O warmObserver eleva o destacado para "metadata" quando a seção entra
      // no viewport, e o click eleva para "auto" via playVideo().
      this.cards.forEach((card) => {
        card.classList.remove('is-visible', 'is-featured');
        const video = card.querySelector('video');
        if (video) video.pause();
      });

      const slotsToShow = Math.min(this.visibleSlots, this.totalCards);
      for (let i = 0; i < slotsToShow; i++) {
        const idx = (this.activeIndex + i) % this.totalCards;
        const card = this.cards[idx];
        card.classList.add('is-visible');
        if (i === 0) card.classList.add('is-featured');
      }

      this.dots.forEach((dot, i) => {
        const isActive = i === this.activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    toggleMute() {
      const isMuted = this.dataset.muted !== 'false';
      this.dataset.muted = isMuted ? 'false' : 'true';

      this.cards.forEach((card) => {
        const video = card.querySelector('video');
        if (video) video.muted = !isMuted ? true : false;
      });

      // Update aria-labels
      const label = isMuted
        ? this.querySelector('.sp-card__mute-btn')?.closest('social-proof-carousel')?.dataset?.sectionId
        : null;
      this.querySelectorAll('.sp-card__mute-btn').forEach((btn) => {
        btn.setAttribute('aria-label', isMuted ? btn.dataset.unmute || 'Unmute' : btn.dataset.mute || 'Mute');
      });
    }

    handleSwipe() {
      const diff = this.touchStartX - this.touchEndX;
      const threshold = 50;
      if (Math.abs(diff) < threshold) return;
      this.navigate(diff > 0 ? 1 : -1);
    }
  }

  customElements.define('social-proof-carousel', SocialProofCarousel);

  } catch(e) { console.error(e); }
})();
})();
